import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root',
})
export class WorkFlowService {
  httpOptions;
  httpBoday = '';
  whoCanSendLetterbyuid;
  constructor(private http: HttpClient) { }


  getWorkFlowData() {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': token,
        'language-iso': 'en',
      }),
    };
    return this.http.get(ApiEndPoint.workflows, this.httpOptions);
  }

  postWorkFlowData(body) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.workflows, body, this.httpOptions);
  }

  updateWorkFlowData(body) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.workflows, body, this.httpOptions);
  }

  updateWorkFloworderData(body) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': token,
        'language-iso': 'en',
      }),
    };

    return this.http.put<any>(ApiEndPoint.updateWorkflow, body, this.httpOptions);
  }

  deleteWorkflow(request) {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'authorization': token,
        'language-iso': 'en',
      }),
    };
    return this.http.put<any>(ApiEndPoint.workflows + "/delete", request, this.httpOptions);
  }
}



